export default "__VITE_ASSET__B8yeR57i__"